/**
 * Installing is left to the browser: Chrome and Edge show their own install prompt
 * (the address-bar button, and on Android the "Add to home screen" sheet) whenever
 * the site qualifies — a manifest, icons and a service worker, all of which the portal
 * has. Nothing here intercepts `beforeinstallprompt`: calling preventDefault on it is
 * precisely what suppresses the browser's own offer.
 */

/** Running as the installed app rather than in a browser tab. */
export const isStandalone = () =>
  (typeof window !== 'undefined' && window.matchMedia?.('(display-mode: standalone)').matches) ||
  (typeof navigator !== 'undefined' && (navigator as { standalone?: boolean }).standalone === true);
